<template>
    <TField label="Content">
        <div>
            <div class="tw-flex">
                <TButton 
                    class="tw-mr-2 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                    @click="showModal = true"><span class="mdi mdi-pencil tw-mr-2"></span>Edit message</TButton>
                <TestSend
                    :comm="comm"
                    :disabled="!canSave"
                    :comm_type="'in-app'"
                    :content="{ message: formattedContent }"
                    size="is-small"
                >
                </TestSend>
            </div>
            <TModal 
                full-screen
                width="tw-w-full"
                v-model="showModal">
                <div class="tw-container tw-mx-auto" >
                    <div class="">
                        <TField label="Message type">
                            <div class="tw-w-80 tw-whitespace-nowrap tw-text-sm tw-flex tw-flex-nowrap">
                                <TRadioButton 
                                    activeClass="tw-text-black tw-bg-gray-300 hover:tw-bg-gray-300 hover:tw-border-blue-500"
                                    class="hover:tw-border-blue-500 tw-rounded-l" value="hero" v-model="templateType">
                                    Hero
                                </TRadioButton>
                                <TRadioButton 
                                    activeClass="tw-text-black tw-bg-gray-300 hover:tw-bg-gray-300 hover:tw-border-blue-500"
                                    class="hover:tw-border-blue-500 tw-rounded-r" value="inbox" v-model="templateType">
                                    Inbox Message
                                </TRadioButton>
                            </div>
                        </TField>
                    </div>
                    <div v-if="templateType === 'hero'" class="tw-grid tw-grid-flow-row tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4">
                        <TField label="Title">
                            <TInput
                                required
                                ref="heroTitle"
                                v-model="heroTemplate.title"
                            ></TInput>
                        </TField>
                        <TField label="Action url" >
                            <TInput
                                ref="heroActionUrl"
                                type="url"
                                v-model="heroTemplate.ctaUrl"
                            ></TInput>
                        </TField>
                        <TField label="Action label">
                            <TInput
                                v-model="heroTemplate.ctaText"
                            ></TInput>
                        </TField>
                        <TField label="Expires at" >
                            <TDatetime
                                v-model="expiresAt"
                            ></TDatetime>
                        </TField>
                        <TField label="Tags">
                            <TTagInput
                                v-model="tags"
                            ></TTagInput>
                        </TField>
                        <TField label="Clear messages with tags">
                            <TTagInput
                                v-model="clearMessagesWithTags"
                            ></TTagInput>
                        </TField>
                        <TField label="Body">
                            <TInput
                                required
                                ref="heroBody"
                                v-model="heroTemplate.body"
                                type="textarea"
                            ></TInput>
                        </TField>
                        <TField label="Rules">
                            <div class="tw-w-full tw-h-full tw-overflow-auto">
                                <RuleBuilder
                                    :custom_class="{'tw-w-full': true}"
                                    placeholder="e.g. roonVersion"
                                    :store="store"
                                    v-model="rules"></RuleBuilder>
                            </div>
                        </TField>
                    </div>
                    <div v-else-if="templateType === 'inbox'" class="tw-grid tw-grid-flow-row tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-4">
                        <TField label="Title">
                            <TInput
                                required
                                ref="inboxTitle"
                                v-model="inboxTemplate.title"
                            ></TInput>
                        </TField>
                        <TField label="Action url" >
                            <TInput
                                ref="inboxActionUrl"
                                type="url"
                                v-model="inboxTemplate.ctaUrl"
                            ></TInput>
                        </TField>
                        <TField label="Action label">
                            <TInput
                                v-model="inboxTemplate.ctaText"
                            ></TInput>
                        </TField>
                        <TField label="Expires at" >
                            <TDatetime
                                v-model="expiresAt"
                            ></TDatetime>
                        </TField>
                        <TField label="Tags">
                            <TTagInput
                                v-model="tags"
                            ></TTagInput>
                        </TField>
                        <TField label="Clear messages with tags">
                            <TTagInput
                                v-model="clearMessagesWithTags"
                            ></TTagInput>
                        </TField>
                        <TField label="Body">
                            <TInput
                                required
                                ref="inboxBody"
                                v-model="inboxTemplate.body"
                                type="textarea"
                            ></TInput>
                        </TField>
                    </div>
                    <div class="tw-flex tw-justify-end">
                        <TButton 
                            class="tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white"
                            @click="showModal = false">Done</TButton>
                    </div>
                </div>
            </TModal>
        </div>
    </TField>
</template>
<style scoped>
</style>
<script>
import { useToast } from "vue-toastification";
import TestSend    from '@/components/TestSend.vue'
import RuleBuilder from '@/components/RuleBuilder.vue'
import {
    TField,
    TInput,
    TButton,
    TDatetime,
    TTagInput,
    TRadioButton,
    TModal,
} from '@roonlabs/vue-tailwind'

// Decode tracked links
function UndoHtmlReplaceLinks(html) {
    const matches = html.matchAll(/\$COMMS_BRIDGE_LINK:([0-9a-zA-Z]+)\$/g);
    let cleaned   = html;
    for ( let match of matches ) {
        const url  = atob(match[1])
        cleaned    = cleaned.replace(match[0], url);
    }
    return cleaned
}


function defaultMessageBody() {
    return {
        title:   null,
        body:    null,
        ctaUrl:  null,
        ctaText: null,
    }
}

export default {
    name: 'InAppContent',
    components: {TModal, TRadioButton, TDatetime, TTagInput, TField, TInput, TButton, RuleBuilder, TestSend},
    props: {
        comm: {
            required: true,
            type:     Object,
        },
        content: {
            type:     Object,
            required: true,
        },

    },
    data() {
        return {
            templateType:           'hero',
            expiresAt:              null,
            clearMessagesWithTags:  [],
            tags:                   [],
            rules:                  null,
            heroTemplate:  defaultMessageBody(),
            inboxTemplate: defaultMessageBody() ,
            showModal: false
        }
    },
    setup() {
        const toast = useToast();
        return { toast }
    },
    methods: {
        defaultInApp() {
            return {
                type: 'hero',
                template: defaultMessageBody(),
                expiresAt: null,
                tags: [],
                clearMessagesWithTags: [],
                rules: null,
            }
        },
        validRules(r) {
            if (!r)
                return false;
            if (r.rules !== undefined) {
                let i = r.rules.length;
                for (let rule of r.rules) {
                    if (!this.validRules(rule)) {
                        return false;
                    }
                }
                return true;

            } else {
                if (!r.field) {
                    return false;
                }
                return true;
            }
        },
        loadOldMessage(m) {
            this.expiresAt                = m.expiresAt; 
            this.tags                     = m.tags || [];
            this.clearMessagesWithTags    = m.clearMessagesWithTags || [];

            var template      = m.template;
            this.templateType = m.type;
            const templateMap = {
                hero:   'heroTemplate',
                inbox:  'inboxTemplate'
            }
            this[templateMap[m.type]] = template;

            // add :STRING back to fields
            const maprulestoui = rules => {
                if ( !rules ) {
                    return null;
                }
                if ( rules.rules !== undefined ) {
                    rules.rules = rules.rules.map(maprulestoui);
                    return rules;
                } else {
                    return {
                        field: rules.field + ':STRING',
                        op: rules.op,
                        value: rules.value
                    }
                }
            }
            const r = maprulestoui(m.rules);
            console.log(r);
            this.rules = r;
        },

        heroIsValid() {
            if ( !this.heroTemplate.title ) {
                this.toast.error("Missing required field: Title")
                return false
            } else if ( !this.heroTemplate.body ) {
                this.toast.error("Missing required field: Body")
                return false
            }
            return true
        },

        inboxIsValid() {
            if ( !this.inboxTemplate.title ) {
                this.toast.error("Missing required field: Title")
                return false
            } else if ( !this.inboxTemplate.body ) {
                this.toast.error("Missing required field: Body")
                return false
            }
            return true
        },
    },
    watch: {
        formattedContent() {
            this.$emit('update:contenterror', !this.canSave);
            this.$emit('save', {'message': this.formattedContent});
        }
    },
    computed: {
        formattedContent() {
            const template = JSON.parse(JSON.stringify(this.templateType === 'hero' ? this.heroTemplate: this.inboxTemplate));

            if (!template.ctaText) delete template.ctaText;
            if (!template.ctaUrl)  delete template.ctaUrl;

            return {
                template,
                type: this.templateType,
                tags:                  this.tags,
                clearMessagesWithTags: this.clearMessagesWithTags,
                ...(this.expiresAt && { expiresAt: this.expiresAt }),
                ...(this.templateType === 'hero' && this.actualRules && { rules: this.actualRules }), // Rules only allowed for hero messages
            }
        },
        store() {
            return {
                fields: [
                    'roonVersion:STRING',
                    'roonPlatform:STRING',
                    'roonProduct:STRING'
                ],
                fields_loading: false,
                getFields: () => {},

                // Override field type ops is OK since these rules are not processed by 
                // commsbridge rules engine
                fieldOps: {
                    'roonVersion:STRING':  ['==','!=','>','>=','<','<='],
                    'roonPlatform:STRING': ['==','!='],
                    'roonProduct:STRING':  ['==','!=']
                }
            }
        },

        actualRules() {
            if ( this.rules?.rules.length === 1 && !!!this.rules.rules[0].field && !!!this.rules.rules[0].value ) {
                return null
            }
            // Replace the :STRING with '' recursively
            const cleanup = rules => {
                if (!rules) return null;
                if ( rules.rules ) {
                    rules.rules = rules.rules.map(cleanup)
                } else {
                    rules.field = rules.field.replace(':STRING', '')
                }
                return rules;
            }
            const r = cleanup(JSON.parse(JSON.stringify(this.rules)));
            console.log(r);
            return r;
        },

        canSave() {
            let valid;
            switch ( this.templateType ) {
                case 'hero':
                    valid = !!this.heroTemplate.title && !!this.heroTemplate.body
                    break;
                case 'inbox':
                    valid = !!this.inboxTemplate.title && !!this.inboxTemplate.body
                    break;
            }
            if ( !valid ) return false;
            if ( this.actualRules && !this.validRules(this.actualRules)) return false;
            return true;
        },
    },
    created() {
        if (this.content.message) {
            this.loadOldMessage(JSON.parse(JSON.stringify(this.content.message)))
        } else {
            this.loadOldMessage(JSON.parse(JSON.stringify(this.defaultInApp())))
        }
    }
}
</script>
